import { useContext, useEffect, useState } from 'react';
import TypingLabel from '../../../common/typing-text';
import APIList from '../../../../http/ApiList';
import { AppContext } from '../../../../contexts/AppContext';
import { Tag } from 'antd';

const StrategicOptionsListContainer: React.FC<any> = (props) => {
  const { property } = props;
  const { authInfo, globalEvent, setGlobalEvent } = useContext(AppContext);
  const [pageOrgData, setPageOrgData] = useState([]);

  const getChatData = (event: string) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        if (res?.data) {
          setPageOrgData(res.data);
          const mapping = {};
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            if (element.tag) {
              mapping[element.option] = element.tag;
            }
          }
          window.localStorage.setItem('optionTags', JSON.stringify(mapping));
        } else {
          setPageOrgData(defaultData);
        }
      });
  };

  useEffect(() => {
    getChatData(globalEvent);
  }, [globalEvent]);

  const defaultData = [
    {
      option: 'title',
      description: 'title',
      type: 'Opportunity & Strength',
      value: 'Opportunity\r\n&\r\nStrength',
    },
    {
      option: 'title',
      description: 'title',
      type: 'Challenge',
      value: 'Challenge',
    },
    {
      option: 'Option-1',
      description: 'XXXXモデル',
      type: 'Opportunity & Strength',
      value: 'XXXXX（独自ビジネスモデル）',
      tag: 'Aggressive',
    },
    {
      option: 'Option-1',
      description: 'XXXXモデル',
      type: 'Challenge',
      value: '企画・事業開発力強化',
      tag: 'Aggressive',
    },
    {
      option: 'Option-1',
      description: 'XXXXモデル',
      type: 'Challenge',
      value: '資金調達・リスクマネジメントの確立',
      tag: 'Aggressive',
    },
    {
      option: 'Option-2',
      description: 'XXXX+XXXモデル',
      type: 'Opportunity & Strength',
      value: '深いEPC知見に基づくXXXアセット',
      tag: 'Aggressive',
    },
    {
      option: 'Option-2',
      description: 'XXXX+XXXモデル',
      type: 'Opportunity & Strength',
      value: 'XXX変革経験（XXX）',
      tag: 'Aggressive',
    },
    {
      option: 'Option-2',
      description: 'XXXX+XXXモデル',
      type: 'Challenge',
      value: 'XXXX型のビジネスモデル確立',
      tag: 'Aggressive',
    },
    {
      option: 'Option-2',
      description: 'XXXX+XXXモデル',
      type: 'Challenge',
      value: '企画・事業開発力強化',
      tag: 'Aggressive',
    },
    {
      option: 'Option-2',
      description: 'XXXX+XXXモデル',
      type: 'Challenge',
      value: '人材獲得・育成',
      tag: 'Aggressive',
    },
    {
      option: 'Option-3',
      description: 'XXXX特化 & XXXXXX利益',
      type: 'Opportunity & Strength',
      value: 'XXXXX（独自ケイパビリティ）',
      tag: 'Aoderate',
    },
    {
      option: 'Option-3',
      description: 'XXXX特化 & XXXXXX利益',
      type: 'Opportunity & Strength',
      value: 'XXXの先進性（XXXX生産性）',
      tag: 'Aoderate',
    },
    {
      option: 'Option-3',
      description: 'XXXX特化 & XXXXXX利益',
      type: 'Opportunity & Strength',
      value: '顧客要求の厳しさ（参入障壁）',
      tag: 'Aoderate',
    },
    {
      option: 'Option-3',
      description: 'XXXX特化 & XXXXXX利益',
      type: 'Challenge',
      value: 'XXXの営業力・自律性確立（XXXの場合）',
      tag: 'Aoderate',
    },
    {
      option: 'Option-3',
      description: 'XXXX特化 & XXXXXX利益',
      type: 'Challenge',
      value: '顧客要求の厳しさへの対応（生産性低下リスク）',
      tag: 'Aoderate',
    },
    {
      option: 'Option-3',
      description: 'XXXX特化 & XXXXXX利益',
      type: 'Challenge',
      value: 'XXX EPCのCommodity化（収益生産性）',
      tag: 'Aoderate',
    },
    {
      option: 'Option-4',
      description: 'XXXX強化',
      type: 'Opportunity & Strength',
      value: 'XXXXとの関係性',
      tag: 'Conservative',
    },
    {
      option: 'Option-4',
      description: 'XXXX強化',
      type: 'Opportunity & Strength',
      value: 'XX志向社員のMotivationとの合致',
      tag: 'Conservative',
    },
    {
      option: 'Option-4',
      description: 'XXXX強化',
      type: 'Challenge',
      value: 'XXX等の競合に対する競争優位確立・差別化',
      tag: 'Conservative',
    },
    {
      option: 'Option-4',
      description: 'XXXX強化',
      type: 'Challenge',
      value: 'XXX案件の開拓ルート（協業先）',
      tag: 'Conservative',
    },
    {
      option: 'Option-5',
      description: 'XXXX強化（XXX含む）',
      type: 'Opportunity & Strength',
      value: '日本のXXXX政策方針',
      tag: 'Conservative',
    },
    {
      option: 'Option-5',
      description: 'XXXX強化（XXX含む）',
      type: 'Opportunity & Strength',
      value: 'XXXX等によるXXXX需要の拡大',
      tag: 'Conservative',
    },
    {
      option: 'Option-5',
      description: 'XXXX強化（XXX含む）',
      type: 'Challenge',
      value: 'ケイパビリティの差別化',
      tag: 'Conservative',
    },
    {
      option: 'Option-5',
      description: 'XXXX強化（XXX含む）',
      type: 'Challenge',
      value: 'XXX EPCのCommodity化（収益生産性）',
      tag: 'Conservative',
    },
  ];

  const temp = pageOrgData.reduce((prev, cur) => {
    let item = prev.find((p) => p.key === cur.option);
    if (cur.option === 'title') {
      if (item) {
        item[cur.type] = cur.value;
      } else {
        prev.push({
          key: cur.option,
          [cur.type]: cur.value,
          description: cur.description,
          tag: cur.tag,
        });
      }
      return prev;
    }
    if (item) {
      if (item[cur.type]) {
        item[cur.type].push(cur.value);
      } else {
        item[cur.type] = [cur.value];
      }
    } else {
      item = {
        key: cur.option,
        [cur.type]: [cur.value],
        description: cur.description,
        tag: cur.tag,
      };
      prev.push(item);
    }
    return prev;
  }, [] as any[]);

  const [checkedIndex, setCheckedIndex] = useState([]);

  const handleOptionClick = (index: number) => {
    if (checkedIndex.includes(index)) {
      setCheckedIndex((prev) => prev.filter((p) => p !== index).sort());
    } else {
      setCheckedIndex((prev) => [...prev, index].sort());
    }
  };

  useEffect(() => {
    if (checkedIndex && checkedIndex.length > 0) {
      window.localStorage.setItem('strategicOptions', JSON.stringify(checkedIndex));
    }
  }, [checkedIndex]);

  const tagColorMap = {
    Aggressive: '#cf1322', // red,
    Aoderate: '#d46b08', // orange,
    Conservative: '#08979c', // cyan,
    Moderate: '#d46b08', // orange
  };

  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      if (entry.target) {
        // // Firefox implements `contentBoxSize` as a single content rect, rather than an array
        let eleTar = document.querySelector('.strategic-option-list .option-area');
        if (!eleTar) {
          return;
        }
        let titleTar = document.querySelector('.strategic-option-list .container-title');
        eleTar.setAttribute('style', `zoom: ${entry.contentRect.height / 900}`);
        // titleTar.setAttribute('style', `zoom: ${entry.contentRect.height / 900}`);
      }
    }
  });

  useEffect(() => {
    setTimeout(() => {
      let strategicContainer = document.querySelector('.strategic-option-list');
      // resizeObserver.observe(strategicContainer);

      let eleTar = document.querySelector('.strategic-option-list .option-area');
      if (!eleTar) {
        return;
      }
      eleTar.setAttribute('style', `zoom: ${(strategicContainer.clientHeight - 20) / 900}`);
    }, 100);
  }, []);

  return (
    <div
      className="strategic-option-container container-layout-area strategic-option-list"
      style={{ fontFamily: 'Meiryo SYSTEM-UI', backgroundImage: `url(${property.backgroundImageUrl})`, backgroundSize: 'cover' }}
    >
      <div className="container-title container-title-strategic">
        <span>5 Strategic Options for 2030</span>
      </div>
      <div className="option-area">
        {temp.map((t, i) => {
          const keys = Object.keys(t).filter((k) => !['key', 'description', 'tag'].includes(k));
          if (t.key !== 'title') {
            return (
              <div className="option-item">
                <div
                  key={`${t.key}-${i}`}
                  className={`option-top title ${checkedIndex.includes(i) ? 'checked' : ''}`}
                  onClick={(e) => {
                    handleOptionClick(i);
                  }}
                >
                  <div className="option-check">{t.key}</div>
                  <div className="o-description">{t.description}</div>
                  <div className="o-tag">
                    <Tag color={tagColorMap[t.tag]} style={{ margin: 0, fontSize: '1rem', padding: '0.3rem 1rem' }}>
                      {t.tag}
                    </Tag>
                  </div>
                </div>
                {keys.map((k, i) => {
                  return (
                    <div className="option-norm item-bg" key={`${k}-${i}`}>
                      {t[k].map((o) => (
                        <div className="o-item" key={o}>
                          <TypingLabel text={o} />
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>
            );
          }
          return (
            <div className="option-item" key={`${t.key}-${i}`}>
              <div className="option-top"></div>
              {keys.map((k) => {
                return (
                  <div className="option-norm title-bg title-col" key={`${k}-${i}`}>
                    <span style={{ fontFamily: 'Meiryo SYSTEM-UI', textAlign: 'center' }}>{t[k]}</span>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StrategicOptionsListContainer;
